import { ExternalLinksFiltersEnum } from "features/Library/ExternalLinks/types/models";
import { type FilterItemBase } from "../FilterFormBuilder/FilterFormBuilder";
import { FilterViewTypes } from "enums/filterViewTypes";

export const getLinkFilters = (
  includePublisher: boolean = true,
  disableDateFilters: boolean = false,
): FilterItemBase<ExternalLinksFiltersEnum>[] => {
  let filters: FilterItemBase<ExternalLinksFiltersEnum>[] = [
    {
      type: FilterViewTypes.DateRange,
      label: "Date Added",
      propertyName: ExternalLinksFiltersEnum.DateCreated,
      otherProps: { disabled: disableDateFilters },
    },
    {
      type: FilterViewTypes.DateRange,
      label: "Last Modified",
      propertyName: ExternalLinksFiltersEnum.DateModified,
      otherProps: { disabled: disableDateFilters },
    },
  ];

  if (includePublisher) {
    filters.push({
      type: FilterViewTypes.MultiSelect,
      label: "Publisher",
      propertyName: ExternalLinksFiltersEnum.Publishers,
      placeholder: "All Publishers",
    });
  }

  filters.push(
    {
      type: FilterViewTypes.MultiSelect,
      label: "Packs",
      propertyName: ExternalLinksFiltersEnum.Packs,
      placeholder: "All Packs",
    },
    {
      type: FilterViewTypes.MultiSelect,
      label: "Software Applications",
      propertyName: ExternalLinksFiltersEnum.SoftwareApplications,
      placeholder: "All Applications",
    },
    {
      type: FilterViewTypes.MultiSelect,
      label: "Labels",
      propertyName: ExternalLinksFiltersEnum.Labels,
      placeholder: "All Labels",
    },
  );

  return filters;
};
